const dateFormatterOptions: Intl.DateTimeFormatOptions = { day: '2-digit', year: '2-digit', month: 'numeric', timeZone: 'America/New_York' };
const dateFormatter = new Intl.DateTimeFormat('en-US', dateFormatterOptions);

export const formatDate = (date: Date | string) => dateFormatter.format(new Date(date));

const numberFormatterCurrencyOptions: Intl.NumberFormatOptions = {
    currencyDisplay: 'symbol',
    style: 'currency',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    currency: 'USD'
};

const numberCurrencyFormatter = new Intl.NumberFormat('en-US', numberFormatterCurrencyOptions);

export const formatCurrency = (amount: number) => numberCurrencyFormatter.format(amount / 100);

const numberFormatterPercentageOptions: Intl.NumberFormatOptions = {
    currencyDisplay: 'symbol',
    style: 'percent',
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
};

const numberPercentageFormatter = new Intl.NumberFormat('en-US', numberFormatterPercentageOptions);

export const formatPercentage = (value: number, divisor: number) => numberPercentageFormatter.format(value / divisor);

export const formatAllCapsLabel = (value: string): string => {
    return value
        .toLowerCase()
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

export const formatCentsToDollars = (value: number) => {
    return (value / 100).toFixed(2);
}

export const formatPriceToCents = (value: string) => {
    return Math.round((parseFloat(value) || 0) * 100);
}

export const formatPhoneToE164 = (value: string): string | null => {
    const digits = value.replace(/\D/g, '');

    if (digits.length === 11 && digits.startsWith('1')) {
        return `+${digits}`;
    }
    if (digits.length === 10) {
        return `+1${digits}`;
    }
    return null;
};

export const formatE164ToPhone = (value: string): string => {
    const digits = value.replace(/\D/g, '');

    const localDigits = digits.length === 11 && digits.startsWith('1')
        ? digits.slice(1)
        : digits;

    if (localDigits.length !== 10) {
        return value;
    }

    const areaCode = localDigits.slice(0, 3);
    const prefix = localDigits.slice(3, 6);
    const lineNumber = localDigits.slice(6);

    return `(${areaCode}) ${prefix}-${lineNumber}`;
};

export const isValidPriceFormat = (value: string): boolean => {
    return /^\d+(\.\d{1,2})?$/.test(value.trim());
};

// For email submissions to prevent malicious values
export const escapeHtml = (value: string): string => value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
;